import './AppAutocomplete.scss';
import {
  Autocomplete,
  AutocompleteChangeDetails,
  AutocompleteChangeReason
} from '@mui/material';
import { KeyboardEvent, SyntheticEvent, useState } from 'react';
import AppText from '../AppText/AppText';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import { visuallyHidden } from '@mui/utils';

interface Props {
  itemList: string[];
  label: string;
  value: string | null;
  width: string;
  onChange: (
    event: SyntheticEvent<Element, Event>,
    value?: string | null,
    reason?: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails<string> | undefined
  ) => void;
}

const AppAutocomplete = ({
  itemList,
  label,
  value,
  width,
  onChange
}: Props) => {
  const [highlightedValue, setHighlightedValue] = useState<string | null>(null);

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      onChange(event, highlightedValue);
    }
  };

  return (
    <Autocomplete
      disablePortal
      forcePopupIcon={false}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      onHighlightChange={(_, option) => setHighlightedValue(option)}
      options={itemList}
      renderInput={(params) => (
        <AppText label={label} width={width} parentField={params} />
      )}
      value={value}
      clearIcon={
        <IconButton aria-label="Clear selection" size="small">
          <ClearIcon />
          <span style={visuallyHidden}>Clear selection</span>
        </IconButton>
      }
      popupIcon={
        <IconButton aria-label="Open dropdown" size="small">
          <ExpandMoreIcon />
          <span style={visuallyHidden}>Open dropdown</span>
        </IconButton>
      }
    />
  );
};

export default AppAutocomplete;
